var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBridgeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.68165C15.2543 7.38863 14.0113 8 12 8C9.98869 8 8.74565 7.38863 8 6.68165V5C8 4.44772 7.55228 4 7 4H5C4.44772 4 4 4.44772 4 5V6.68174C3.54195 7.11604 2.89622 7.51425 2 7.75683V9.81049C2.76637 9.65549 3.42971 9.41332 4 9.11339V12H2V15H4V18C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18V15H16V18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18V15H22V12H20V9.11334C20.5703 9.41329 21.2337 9.65548 22.0001 9.81049V7.75683C21.1038 7.51424 20.4581 7.11598 20 6.68166V5C20 4.44772 19.5523 4 19 4H17C16.4477 4 16 4.44772 16 5V6.68165ZM8 12V9.11329C9.01795 9.64866 10.3324 10 12 10C13.6676 10 14.982 9.64866 16 9.11329V12H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeAlt);
export default __webpack_public_path__ + "static/media/bridge-alt.652f24593000e55e0298c50430bc69d5.svg";
export { ForwardRef as ReactComponent };